import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68f80ffd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message" }
const _hoisted_2 = { class: "create" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "ws_mb20" }
const _hoisted_5 = { class: "ws_mb20" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "dialog-footer" }

import { ref, onMounted } from 'vue'
import {
  sendbackQuery,
  sendbackAddOrUpdate,
  sendbackTesturl,
  sendbackDelete,
} from '@/api'
import { CODE_ENUM } from '@/common/enum'
import { ElMessage } from 'element-plus'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const formRef = ref()
const rules = {
  notifyUrl: {
    required: true,
    message: t('C_MSG.enter'),
  },
}
const formData = ref({
  notifyUrl: '',
})
// 原本数据
const originData = ref('')

onMounted(() => {
  queryNotifyUrl()
})

const queryNotifyUrl = async () => {
  const res: any = await sendbackQuery()
  if (res?.code === CODE_ENUM.SUCCESS) {
    formData.value.notifyUrl = res.data || ''
    originData.value = res.data || ''
  }
}

const loading = ref(false)
const toSave = async () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const { notifyUrl } = formData.value
      loading.value = true
      const res: any = await sendbackAddOrUpdate({
        notifyUrl,
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage.success(t('C_MSG.saveSuccess'))
        originData.value = notifyUrl
      }
    }
  })
}

const testLoading = ref(false)
const toTest = async () => {
  const { notifyUrl } = formData.value
  testLoading.value = true
  const res: any = await sendbackTesturl({
    notifyUrl,
  }).finally(() => {
    testLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(t('C_MSG.testSuccess'))
  }
}

const deleteDialogVisible = ref(false)
const deleteLoading = ref(false)
const toDelete = async () => {
  deleteLoading.value = true
  const res: any = await sendbackDelete().finally(() => {
    deleteLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(t('C_MSG.delSuccess'))
    deleteDialogVisible.value = false
    formRef.value.resetFields()
    originData.value = ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('C_MSG.title')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('C_MSG.tip')), 1),
          _createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: formData.value,
            rules: rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 22 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { prop: "notifyUrl" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: formData.value.notifyUrl,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.notifyUrl) = $event)),
                            modelModifiers: { trim: true },
                            placeholder: _ctx.$t('C_MSG.notifyUrlPla'),
                            type: "textarea",
                            rows: 1
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 2 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        onClick: toTest,
                        disabled: !formData.value.notifyUrl,
                        class: "ws_ml8"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('C_MSG.btnTest')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_el_button, {
            onClick: toSave,
            loading: loading.value,
            class: "ws_mt30 ws_mb20",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('C_MSG.btnSave')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteDialogVisible.value = true)),
            disabled: !originData.value,
            class: "ws_mt30 ws_mb20 ws_ml20",
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('C_MSG.btnDel')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: deleteDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((deleteDialogVisible).value = $event)),
      width: "500px"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_icon, {
            color: "#F56C6C",
            size: "26",
            class: "ws_mr10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_WarningFilled)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('C_MSG.delTitle')), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteDialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('C_MSG.btnCancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            loading: deleteLoading.value,
            type: "primary",
            onClick: toDelete
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('C_MSG.btnDel')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('C_MSG.delTip')), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})